<template>
  <v-container class="pa-0" fluid>
    <v-row class="ma-0 ma-md-2">
      <v-col cols="12">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>
              <v-avatar height="32px" class="mx-auto">
                <videon-logo />
              </v-avatar>
              API Access
            </v-toolbar-title>
          </v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-alert dense outlined type="error" v-if="error" class="mb-4">
              {{ errorText }}
            </v-alert>
            <div v-if="loading" class="text-center pa-5">
              <v-progress-circular indeterminate color="primary" />
            </div>
            <v-row v-else-if="!error && !entitled" class="text-center">
              <v-col cols="12">
                <span class="text--disabled">Cloud Pro API is not licensed for this organization.</span>
              </v-col>
            </v-row>
            <div v-else-if="entitled">
              <v-alert dense outlined type="info" class="mb-4">
                Browser Cloud UI traffic (JWT) is not counted. PAT calls use the same API
                host and paths. Send <code>Org-Guid</code> on every PAT request so usage
                is attributed to that organization.
              </v-alert>
              <p class="subtitle-1">
                Included monthly quota
                <strong v-if="usage">{{ usage.allowance }}</strong>
                requests. Reset {{ formattedResetAt }}.
              </p>
              <v-btn text color="primary" to="/api-usage" class="mb-4">
                Open API Usage Explorer
              </v-btn>
              <access-tokens-box :user_guid="guid" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import AccessTokensBox from '../components/user/AccessTokens.vue'

  export default {
    name: 'ApiAccess',
    components: { AccessTokensBox },
    data() {
      return {
        loading: true,
        entitled: false,
        usage: null,
        error: false,
        errorText: '',
      }
    },
    computed: {
      ...mapGetters('user', ['guid']),
      formattedResetAt() {
        return this.usage && this.usage.reset_at
          ? moment(this.usage.reset_at).format('MMM D, YYYY HH:mm Z')
          : 'unknown'
      },
    },
    mounted() {
      this.load()
    },
    methods: {
      load() {
        this.loading = true
        this.error = false
        this.errorText = ''
        this.axios.get('/usage').then((response) => {
          this.usage = response.data
          this.entitled = !!response.data.entitled
          this.loading = false
        }).catch((error) => {
          this.error = true
          this.errorText = this.$helpers.parseError(error)
          this.entitled = false
          this.loading = false
        })
      }
    }
  }
</script>
